import React from 'react';
import { APP_CONFIG } from '../../config/appConfig';

interface AdSlotProps {
  slotId?: string;
  format?: 'horizontal' | 'rectangle' | 'vertical';
  className?: string;
}

export const AdSlot: React.FC<AdSlotProps> = ({
  slotId = 'default',
  format = 'horizontal',
  className = '',
}) => {
  const isEnabled = APP_CONFIG.monetization.adsense.enabled;
  const clientId = APP_CONFIG.monetization.adsense.clientId;

  // Reserved min-heights to eliminate Cumulative Layout Shift (CLS)
  const formatHeights = {
    horizontal: 'min-h-[90px] max-w-[728px]',
    rectangle: 'min-h-[250px] max-w-[300px]',
    vertical: 'min-h-[600px] max-w-[160px]',
  };

  // If AdSense is not configured (e.g. initial $0 launch before publisher approval),
  // render an unobtrusive reserved container that never breaks layout or shows fake ads.
  if (!isEnabled || !clientId) {
    return (
      <div
        className={`w-full mx-auto my-4 border border-dashed border-slate-200 rounded-lg flex items-center justify-center text-slate-400 text-xs select-none p-3 ${formatHeights[format]} ${className}`}
        aria-hidden="true"
      >
        <span className="text-[11px] uppercase tracking-wider text-slate-400 font-mono">
          Advertisement Space
        </span>
      </div>
    );
  }

  return (
    <aside
      aria-label="Advertisement"
      className={`w-full mx-auto my-4 overflow-hidden flex flex-col items-center justify-center ${formatHeights[format]} ${className}`}
    >
      <div className="text-[10px] uppercase text-slate-400 tracking-wider mb-1 self-start">
        Sponsored
      </div>
      {/* Real AdSense tag will mount here once approved */}
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={clientId}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </aside>
  );
};

